import React, {Component} from 'react';
import { connect } from "react-redux";
import * as RoleType from "../../constants/user/RoleType";

@connect(state => ({
    currentUserRole : state.user.role,
    currentUserName : state.user.name,
}), dispatch => ({
}))
class NotAuthorized extends Component {
    constructor(props) {
        super(props);
    }

    render() {

        const { currentUserRole, currentUserName, pageRequireRole } = this.props;

        // 방문자인 경우에 login url 로 이동시킴.
        if(RoleType.convertStringToRoleType(currentUserRole) === RoleType.GUEST){
            if (window.appInfo.loginUrl) {
            	window.location = `${window.appInfo.loginUrl}?redirectUrl=${encodeURIComponent(window.location.href)}`
            } else {
            	window.location = window.Config.blog.domain
            }
            return null;
        }
        return (
                <div className="inner_article">
                    <h2 id="kakaoBody" className="screen_out">블로그관리 본문</h2>
                    <div className="info_none">
                        <p className="txt_none">
                            <span className="wrap_ico"><span className="ico_blog ico_post"/></span>
                            {RoleType.getRoleLabel(pageRequireRole)} 이상만 접근 가능한 메뉴입니다. <br/>
                            {currentUserName}님의 권한은 <em className="txt_emph">{RoleType.getRoleLabel(currentUserRole)}</em>입니다.
                        </p>
                    </div>

                </div>
        );
    }
}

export default NotAuthorized;
